import { useAuthentication } from "../../customHooks/useAuthentication";
import { getBearerToken } from "../../utils/sessionAuth";
import Login from "../../views/login/Login";
import ErrorBoundary from '../ErrorBoundary'

function WithAuthenticationListener(WrappedComponent) {
	return function WrappedComponentWithAuthentication(props) {
		const { currentToken } = useAuthentication();
		const isAuthenticated = Boolean(currentToken || getBearerToken());

		return (
			<>
				{isAuthenticated ? (
					<ErrorBoundary>
						<WrappedComponent>{props.children}</WrappedComponent>
					</ErrorBoundary>
				) : (
					<ErrorBoundary>
						<Login />
					</ErrorBoundary>
				)}
			</>
		);
	};
}

export { WithAuthenticationListener };
